/**
 * @flow
 * @relayHash 6db8fe2f29c6c3c28862af0f847015e8
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type VerifyPhoneInput = {
  clientMutationId?: ?string,
  id: string,
  verification_code: string,
};
export type SMSNotifications_verifyPhoneMutationVariables = {|
  input: VerifyPhoneInput
|};
export type SMSNotifications_verifyPhoneMutationResponse = {|
  +verifyPhone: ?{|
    +phone: ?{|
      +id: string,
      +number: ?string,
      +verified: ?boolean,
    |}
  |}
|};
export type SMSNotifications_verifyPhoneMutation = {|
  variables: SMSNotifications_verifyPhoneMutationVariables,
  response: SMSNotifications_verifyPhoneMutationResponse,
|};
*/


/*
mutation SMSNotifications_verifyPhoneMutation(
  $input: VerifyPhoneInput!
) {
  verifyPhone(input: $input) {
    phone {
      id
      number
      verified
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "VerifyPhoneInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "verifyPhone",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "VerifyPhoneInput!"
      }
    ],
    "concreteType": "VerifyPhonePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "phone",
        "storageKey": null,
        "args": null,
        "concreteType": "Phone",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "verified",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "SMSNotifications_verifyPhoneMutation",
  "id": null,
  "text": "mutation SMSNotifications_verifyPhoneMutation(\n  $input: VerifyPhoneInput!\n) {\n  verifyPhone(input: $input) {\n    phone {\n      id\n      number\n      verified\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SMSNotifications_verifyPhoneMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "SMSNotifications_verifyPhoneMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b7bae802153826e66c6be3d999dd9569';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Leads/__generated__/SMSNotifications_verifyPhoneMutation.graphql.js